import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { MindMapNode } from '../types';

interface Props {
    node: MindMapNode;
    expanded: boolean;
}

export function NodeImageSlider({ node, expanded }: Props) {
    const [idx, setIdx] = useState(0);

    const imgs = [
        ...(node.imageBase64 ? [node.imageBase64] : []),
        ...(node.drawingBase64 ? [node.drawingBase64] : []),
        ...(node.attachments || []).filter(a => a.type === 'image').map(a => a.content),
    ].filter(Boolean) as string[];

    useEffect(() => { setIdx(0); }, [node.id]);

    if (imgs.length === 0) return null;

    if (expanded) {
        return (
            <div className="flex flex-col shrink-0 divide-y divide-gray-100 dark:divide-slate-700 border-b border-gray-100 dark:border-slate-700">
                {imgs.map((src, i) => (
                    <img key={i} src={src} alt="" className="w-full object-contain max-h-[400px]" />
                ))}
            </div>
        );
    }

    const safeIdx = Math.min(idx, imgs.length - 1);
    return (
        <div className="relative shrink-0 border-b border-gray-100 dark:border-slate-700">
            <img src={imgs[safeIdx]} alt="" className="w-full max-h-44 object-cover" />
            {imgs.length > 1 && (
                <>
                    <span className="absolute bottom-1.5 right-2 bg-black/50 text-white text-[10px] px-1.5 py-0.5 rounded-full leading-none pointer-events-none">
                        {safeIdx + 1}/{imgs.length}
                    </span>
                    {safeIdx > 0 && (
                        <button
                            onClick={(e) => { e.stopPropagation(); setIdx(i => i - 1); }}
                            className="absolute left-1 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full p-0.5 transition-colors"
                        >
                            <ChevronLeft size={14} />
                        </button>
                    )}
                    {safeIdx < imgs.length - 1 && (
                        <button
                            onClick={(e) => { e.stopPropagation(); setIdx(i => i + 1); }}
                            className="absolute right-1 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full p-0.5 transition-colors"
                        >
                            <ChevronRight size={14} />
                        </button>
                    )}
                </>
            )}
        </div>
    );
}
